import React from 'react'
import { ImageChoiceCol } from '../../../theme'

const ROW_COUNT = 2
const COL_COUNT = 2

function ImageChoices(props) {
  const {
    value,
    onSelect,
    choices,
    correctIndex,
    neutralQuestion,
    confirmResult,
    parentScreen,
    selected,
    quesType,
    quesId,
    finalAttempt,
  } = props
  return (
    <>
      <div
        className="mt-4"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          gridGap: '10px',
        }}
      >
        {choices.map((choice, index) => (
          <ImageChoiceCol
            onClick={() => value == null && onSelect(index, quesId)}
            selectedAns={
              quesType === 'worksheet' && !finalAttempt && value !== null
                ? value === index && correctIndex === index
                  ? '#39c979'
                  : value === index && correctIndex !== index
                  ? '#EBAEAF'
                  : ''
                : ''
            }
            correct={
              !quesType || finalAttempt
                ? parentScreen
                  ? selected === index
                  : value !== null && correctIndex === index
                  ? 1
                  : 0
                : 0
            }
            wrong={
              !quesType || finalAttempt
                ? parentScreen
                  ? null
                  : value !== null && correctIndex !== index && value === index
                  ? true
                  : false
                : 0
            }
          >
            <img
              style={{
                height: '120px',
                width: '85%',
                OObjectFit: 'contain',
                margin: '8px',
                padding: '0px',
                borderRadius: '4px',
              }}
              src={choice}
            />{' '}
          </ImageChoiceCol>
        ))}
      </div>
    </>
  )
}

export default ImageChoices
